import { DndContext, DragEndEvent } from '@dnd-kit/core'
import { restrictToVerticalAxis } from '@dnd-kit/modifiers'
import { SortableContext, arrayMove, verticalListSortingStrategy } from '@dnd-kit/sortable'
import { message, Table } from 'antd'
import { FC, useEffect, useMemo, useState } from 'react'
import styled from 'styled-components'
import TableWrapper from '../../../../../../../components/table-wrapper/table-wrapper'
import {
    useGetRewindQueueEntriesQuery,
    useReorderRewindQueueEntriesMutation,
} from '../../../../../../../store/api/rewind-queue-entries-api'
import RewindQueueEntry from '../../../../../../../types/api/rewind-queue-entry'
import { DocumentId } from '../../../../../../../types/strapi/strapi'
import CustomRow from '../../../../../flexo/components/machines-queues/components/custom-row'
import { getRewindQueueQuery } from '../../../../constants/query-params'
import { columns } from '../../columns'

const TableWrapperStyled = styled(TableWrapper)`
    flex: auto;
    height: 100%;
    width: 100%;
`

interface MachineQueueProps {
    machineDocId: DocumentId
}

const MachineQueue: FC<MachineQueueProps> = ({ machineDocId }) => {
    const queryParams = useMemo(() => getRewindQueueQuery(machineDocId), [machineDocId])
    const { data, isLoading } = useGetRewindQueueEntriesQuery(queryParams)
    const [reorder] = useReorderRewindQueueEntriesMutation()
    const [dataSource, setDataSource] = useState<RewindQueueEntry[]>([])

    useEffect(() => {
        setDataSource(data?.data || [])
    }, [data?.data])

    const onDragEnd = ({ active, over }: DragEndEvent) => {
        if (active.id === over?.id) return

        setDataSource(prevState => {
            const activeIndex = prevState.findIndex(record => record.id === active?.id)
            const overIndex = prevState.findIndex(record => record.id === over?.id)

            if (activeIndex < 0 || overIndex < 0) return prevState

            const newOrder = arrayMove(prevState, activeIndex, overIndex)

            reorder({
                data: newOrder.map((item, index) => ({ documentId: item.documentId, sort: index })),
            })
                .unwrap()
                .catch(() => {
                    setDataSource(prevState)
                    message.error('Не удалось сохранить порядок очереди перемотки')
                })

            return newOrder
        })
    }

    return (
        <DndContext modifiers={[restrictToVerticalAxis]} onDragEnd={onDragEnd}>
            <SortableContext items={dataSource.map(item => item.id)} strategy={verticalListSortingStrategy}>
                <TableWrapperStyled tableHasNotPagination filtersSummaryHeight={0}>
                    <Table
                        dataSource={dataSource}
                        columns={columns}
                        pagination={false}
                        rowKey='id'
                        size='small'
                        loading={isLoading}
                        components={{ body: { row: CustomRow } }}
                    />
                </TableWrapperStyled>
            </SortableContext>
        </DndContext>
    )
}

export default MachineQueue
